import type { LoomductConfig } from './types'

export type SkipReason =
  | 'token'
  | 'host'
  | 'protocol'
  | 'localhost'
  | 'automation'
  | 'opt-out'

export const defaultHost = 'https://api.loomduct.com'

export function isOptedOut(): boolean {
  try {
    return localStorage.getItem('loomduct_ignore') === 'true'
  } catch {
    return false
  }
}

export function findSkipReason(config: LoomductConfig): SkipReason | undefined {
  const host = config.host ?? defaultHost
  const { protocol, hostname } = location
  const page = window as unknown as Record<string, unknown>
  if (!config.token) {
    return 'token'
  }
  if (
    !host.startsWith('https://') &&
    (!host.startsWith('/') || host.startsWith('//'))
  ) {
    return 'host'
  }
  if (!protocol.startsWith('http')) {
    return 'protocol'
  }
  if (
    !config.allowLocalhost &&
    (hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === '[::1]' ||
      hostname.endsWith('.localhost') ||
      hostname.endsWith('.local'))
  ) {
    return 'localhost'
  }
  if (
    !config.allowAutomation &&
    (navigator.webdriver ||
      'Cypress' in page ||
      '_phantom' in page ||
      '__nightmare' in page)
  ) {
    return 'automation'
  }
  if (isOptedOut()) {
    return 'opt-out'
  }
  return undefined
}
